module.exports = "<a class=\"btn btn-success legacyAppButton\" [href]=legacyAppSite TARGET=\"_blank\">Legacy App</a>\n"